import type {CheckoutCarRentalService} from "./carRental";
import type {CheckoutPerParticipantService} from "./perParticipant";
import type {CheckoutPerBookingService} from "./perBooking";
import type {CheckoutPerRoomService} from "./perRoom";
import type {CheckoutLuggageService} from "./luggage";
import type {CheckoutBookingRedeemerService} from "./redeemer";
import type {CheckoutSkiAncillaryService} from "./ski";
import type {CheckoutClothingService} from "./clothing";
import type {CheckoutBusService} from './bus';

export const enum ServiceType {
  CarRental = 'carRental',
  CarRentalFiltering = 'carRentalFiltering',
  TravelInsurance = 'travelInsurance',
  TravelInsurancePerBooking = 'travelInsurancePerBooking',
  CancellationInsurance = 'cancellationInsurance',
  CancellationInsurancePerBooking = 'cancellationInsurancePerBooking',
  Transfer = 'transfer',
  Visa = 'visa',
  Rebooking = 'rebooking',
  Babycot = 'babycot',
  Bus = 'bus',
  MealplanDP = 'mealplanDP',
  Mealplan = 'mealplan',
  MealplanExternal = 'mealplanExternal',
  Breakfast = 'breakfast',
  BreakfastArrivalBus = 'breakfastArrivalBus',
  Dinner = 'dinner',
  Luggage = 'luggage',
  BookingRedeem = 'bookingRedeem',
  SkiPass = 'skiPass',
  SkiMaterial = 'skiMaterial',
  SkiLesson = 'skiLesson',
  Sweater = 'sweater',
  TShirt = 'tShirt',
  DutchweekValThorens = 'dutchweekValThorens',
  Dutchweek = 'dutchweek',
  Comedy = 'comedy',
  ParkingAirport = 'parkingAirport',
  SkiTransfer = 'skiTransfer',
  SkiTransferPerBooking = 'skiTransferPerBooking',
  SkiCarriage = 'skiCarriage',
  PartyTickets = 'partyTickets',
  Golf = 'golf',
  DinnerVouchers = 'dinnerVouchers',
  Bridge = 'bridge',
  GenericServicePerBooking = 'genericServicePerBooking',
  GenericServicePerParticipant = 'genericServicePerParticipant',
  GenericServicePerRoom = 'genericServicePerRoom',
  ESim = 'eSim',
  BikeRental = 'bikeRental',
}

export interface CheckoutService {
  id: string;
  isSelected: boolean;
  type: ServiceType;
}

export interface Services {
  [ServiceType.CarRental]: CheckoutCarRentalService;
  [ServiceType.CarRentalFiltering]: CheckoutCarRentalService;
  [ServiceType.TravelInsurance]: CheckoutPerParticipantService;
  [ServiceType.TravelInsurancePerBooking]: CheckoutPerBookingService;
  [ServiceType.CancellationInsurance]: CheckoutPerBookingService;
  [ServiceType.CancellationInsurancePerBooking]: CheckoutPerBookingService;
  [ServiceType.Transfer]: CheckoutPerBookingService;
  [ServiceType.Visa]: CheckoutPerBookingService;
  [ServiceType.Rebooking]: CheckoutPerBookingService;
  [ServiceType.Babycot]: CheckoutPerParticipantService;
  [ServiceType.MealplanDP]: CheckoutPerRoomService;
  [ServiceType.Mealplan]: CheckoutPerRoomService;
  [ServiceType.MealplanExternal]: CheckoutPerRoomService;
  [ServiceType.Breakfast]: CheckoutPerRoomService;
  [ServiceType.BreakfastArrivalBus]: CheckoutPerRoomService;
  [ServiceType.Dinner]: CheckoutPerRoomService;
  [ServiceType.Luggage]: CheckoutLuggageService;
  [ServiceType.BookingRedeem]: CheckoutBookingRedeemerService;
  [ServiceType.SkiPass]: CheckoutSkiAncillaryService;
  [ServiceType.SkiMaterial]: CheckoutSkiAncillaryService;
  [ServiceType.SkiLesson]: CheckoutSkiAncillaryService;
  [ServiceType.Sweater]: CheckoutClothingService;
  [ServiceType.TShirt]: CheckoutClothingService;
  [ServiceType.DutchweekValThorens]: CheckoutPerParticipantService;
  [ServiceType.Dutchweek]: CheckoutPerParticipantService;
  [ServiceType.Comedy]: CheckoutPerParticipantService;
  [ServiceType.ParkingAirport]: CheckoutPerBookingService;
  [ServiceType.SkiTransfer]: CheckoutPerParticipantService;
  [ServiceType.SkiTransferPerBooking]: CheckoutPerBookingService;
  [ServiceType.SkiCarriage]: CheckoutPerParticipantService;
  [ServiceType.PartyTickets]: CheckoutPerParticipantService;
  [ServiceType.Bus]: CheckoutBusService;
  [ServiceType.Golf]: CheckoutPerParticipantService;
  [ServiceType.Bridge]: CheckoutPerParticipantService;
  [ServiceType.DinnerVouchers]: CheckoutPerBookingService;
  [ServiceType.GenericServicePerBooking]: CheckoutPerBookingService;
  [ServiceType.GenericServicePerParticipant]: CheckoutPerParticipantService;
  [ServiceType.GenericServicePerRoom]: CheckoutPerRoomService;
  [ServiceType.ESim]: CheckoutPerParticipantService;
  [ServiceType.BikeRental]: CheckoutPerParticipantService;
}

export * from './common'
export * from './carRental'
export * from './golf'
export * from './luggage'
export * from './perBooking'
export * from './perParticipant'
export * from './perRoom'
export * from './redeemer'
export * from './ski'
export * from './clothing'
export * from './bus'
